// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextRendererCollapsed__container-d51cc4 {
  --rows: 2;
  --line-height: 22px;
  display: -webkit-box;
  -webkit-line-clamp: var(--rows);
  -webkit-box-orient: vertical;
  max-height: calc(var(--line-height) * var(--rows));
  overflow: hidden;
  text-overflow: ellipsis;
}

.TextRendererCollapsed__text-b651d8 {
  display: inline;
  line-height: var(--line-height) !important;
}

.TextRendererCollapsed__button-a2401c {
  height: 24px;
  margin-top: 6px;
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  text-decoration: none;
  cursor: pointer;
}

.TextRendererCollapsed__button-a2401c:hover,
.TextRendererCollapsed__button-a2401c:active,
.TextRendererCollapsed__button-a2401c:focus {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/TextRendererCollapsed/styles.m.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,mBAAA;EAEA,oBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kDAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,0CAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;AAAF;;AAGA;;;EAGE,0BAAA;AAAF","sourcesContent":[".container {\n  --rows: 2;\n  --line-height: 22px;\n\n  display: -webkit-box;\n  -webkit-line-clamp: var(--rows);\n  -webkit-box-orient: vertical;\n  max-height: calc(var(--line-height) * var(--rows));\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text {\n  display: inline;\n  line-height: var(--line-height) !important;\n}\n\n.button {\n  height: 24px;\n  margin-top: 6px;\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.button:hover,\n.button:active,\n.button:focus {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextRendererCollapsed__container-d51cc4`,
	"text": `TextRendererCollapsed__text-b651d8`,
	"button": `TextRendererCollapsed__button-a2401c`
};
module.exports = ___CSS_LOADER_EXPORT___;
